var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90625 15H8.90625",
    stroke: "#34495E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05539 6.00106C2.0512 5.34112 2.17809 4.68691 2.4287 4.07639C2.67931 3.46586 3.04865 2.91118 3.5153 2.44451C3.98195 1.97784 4.53662 1.60848 5.14713 1.35785C5.75765 1.10722 6.41185 0.980304 7.07179 0.984475C7.73174 0.988645 8.38429 1.12382 8.99158 1.38215C9.59888 1.64047 10.1488 2.01682 10.6096 2.48935C11.0703 2.96187 11.4326 3.52118 11.6754 4.13482C11.9183 4.74846 12.0369 5.40422 12.0244 6.06406V6.55706C11.9321 8.1882 12.2693 9.81502 13.0024 11.2751C13.0519 11.3593 13.0782 11.4552 13.0788 11.5529C13.0793 11.6506 13.0541 11.7467 13.0056 11.8315C12.9571 11.9164 12.8871 11.9869 12.8026 12.036C12.7181 12.085 12.6221 12.111 12.5244 12.1111H1.55439C1.45668 12.111 1.36073 12.085 1.27623 12.036C1.19174 11.9869 1.1217 11.9164 1.07319 11.8315C1.02469 11.7467 0.999448 11.6506 1.00001 11.5529C1.00057 11.4552 1.02692 11.3593 1.07639 11.2751C1.80986 9.81548 2.14744 8.18897 2.05539 6.55806V6.00106Z",
    stroke: "#34495E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_Icon.efef2c22.svg";
export { ForwardRef as ReactComponent };